<div class="fusion-footer">
	<footer class="fusion-footer-widget-area fusion-widget-area">
		<div class="fusion-row">
				<div class="fusion-columns fusion-columns-4 fusion-widget-area">
					<div class="fusion-column col-lg-5 col-md-5 col-sm-5">
						<div id="text-3" class="fusion-footer-widget-column widget widget_text">
							<div class="textwidget">
								<img src="assets/images/uib-logo-500-white.png" width="160" height="93" alt="uib"><br><br>
								<span class="cbc_content">{{ 'Footer.Add1' | translate }}, <br>{{ 'Footer.Add2' | translate }}, <br>{{ 'Footer.Add3' | translate }}<br><br>
								<a href="tel:+6568714035" target="_blank">{{ 'Footer.Phone' | translate }}</a></span><br><br><a href="mailto:info@uib.ai" target="_blank">{{ 'Footer.Mail' | translate }}</a><br>
									<a href="https://uib.ai/" target="_blank">{{ 'Common.Site' | translate }}</a><br><br>
									<div class="fusion-button-wrapper">
										<a target="_blank" title="Facebook" href="https://www.facebook.com/unifiedinbox" class="fusion-button button-flat button-round button-small button-default button-3 footericons"><div class="fa fa-facebook button-icon-left"></div></a>
										<a target="_blank" title="Twitter" href="http://twitter.com/unifiedinbox" class="fusion-button button-flat button-round button-small button-default button-3 footericons"><div class="fa fa-twitter button-icon-left"></div></a>
										<a target="_blank" title="Google+" href="https://plus.google.com/u/0/100348708067955188095/posts" class="fusion-button button-flat button-round button-small button-default button-3 footericons"><div class="fa fa-google button-icon-left"></div></a>
										<a target="_blank" title="LinkedIn" href="http://www.linkedin.com/company/1179990?trk=tyah" class="fusion-button button-flat button-round button-small button-default button-3 footericons"><div class="fa fa-linkedin button-icon-left"></div></a>
										<a target="_blank" title="Youtube" href="http://www.youtube.com/channel/UC5-Wgrb8fONRY6h9h3o8tGg" class="fusion-button button-flat button-round button-small button-default button-3 footericons"><div class="fa fa-youtube-play button-icon-left"></div></a>
										<a target="_blank" title="StackOverflow" href="https://stackoverflow.com/questions/tagged/unificationengine" class="fusion-button button-flat button-round button-small button-default button-3 footericons"><div class="fa fa-stack-overflow button-icon-left"></div></a>
										<a target="_blank" title="GitHub" href="https://github.com/unifiedinbox/" class="fusion-button button-flat button-round button-small button-default button-3 footericons">
										<div class="fa fa-github-square button-icon-left"></div></a>
								</div>
							</div>
						</div>
				</div>
				<div class="fusion-column col-lg-5 col-md-5 col-sm-5">
					<div id="text-2" class="fusion-footer-widget-column widget widget_text">
						<h4 class="widget-title">{{ 'Footer.Company' | translate }}</h4>
						<div class="textwidget">
							<p>
								<a href="https://uib.ai/story/" target="_blank">{{ 'Footer.OurStory' | translate }}</a><br>
								<a href="https://uib.ai/blog/" target="_blank">{{ 'Footer.Blog' | translate }}</a><br>
								<a href="https://uib.pr.co/" target="_blank">{{ 'Footer.Press' | translate }} &amp; {{ 'Footer.Media' | translate }}</a><br>
								<a href="https://uib.ai/careers/" target="_blank">{{ 'Footer.Careers' | translate }}</a><br>
								<a href="https://uib.ai/legal/" target="_blank">{{ 'Footer.Legal' | translate }}</a>
							</p>
						</div>
					</div>
				</div>
				<div class="fusion-column col-lg-2 col-md-2 col-sm-2">
					<div id="text-4" class="fusion-footer-widget-column widget widget_text">
						<h4 class="widget-title">{{ 'Footer.Developers' | translate }}</h4>
						<div class="textwidget">
							<p>
								<a href="https://developer.unificationengine.com" target="_blank">{{ 'Common.Documentation' | translate }}</a><br>
								<a href="https://github.com/unifiedinbox" target="_blank">{{ 'Footer.SDKs' | translate }}</a><br>
								<a href="https://developer.unificationengine.com" target="_blank">{{ 'Footer.Pricing' | translate }}</a><br>
								<a href="https://stackoverflow.com/questions/tagged/unificationengine" target="_blank">{{ 'Footer.Forum' | translate }}</a><br>
								<a href="#" target="_blank">{{ 'Footer.APIStatus' | translate }}</a>
							</p>
							<!-- <div class="fusion-button-wrapper">
								<p>
									<a target="_blank" title="Developer Portal Login" href="/" class="fusion-button button-flat button-round button-medium button-custom button-10"><span class="fusion-button-text">{{ 'Common.Login' | translate }}</span></a>
								</p>
							</div>
							<div class="fusion-button-wrapper">
								<p>
									<a target="_blank" title="Developer Signup" href="/" class="fusion-button button-flat button-round button-medium button-custom button-10">
									<span class="fusion-button-text">{{ 'Footer.Signup' | translate }}</span>
									</a>
								</p>
							</div> -->
						</div>
					</div>
				</div>
				
				<!--<div class="fusion-column col-lg-3 col-md-3 col-sm-3">
					<div class="fusion-footer-widget-column widget widget_text">
						<h4 class="widget-title">{{ 'Footer.Solutions' | translate }}</h4>
						<div class="textwidget">
							<p>
								<a href="https://www.outbox.pro/" target="_blank">{{ 'Footer.OutboxPro' | translate }}</a><br>
								<a href="http://unified.pro/" target="_blank">{{ 'Footer.UnifiedPro' | translate }}</a><br>
								<a href="http://www.socialgrow.com/" target="_blank">{{ 'Footer.SocialGrow' | translate }}</a><br>
								<a href="http://mediaflow.ac/" target="_blank">{{ 'Footer.MediaFlow' | translate }}</a><br><a href="#" target="_blank">{{ 'Footer.OpenInbox' | translate }}</a>
							</p>
						</div>
					</div>
				</div>-->
			</div>
		</div>
	</footer>
	<div class="fusion-clearfix"></div>
	<footer id="footer" class="fusion-footer-copyright-area">
		<div class="fusion-row">
			<div class="fusion-copyright-content">
				<div class="fusion-copyright-notice">
				<div>
					<div class="leftfooter">© {{ currentYear }}<a href="https://uib.ai/" target="_blank">{{ 'Common.Site' | translate }}</a>{{ 'Footer.CopyRight' | translate }}.</div>
					<div class="rightfooter">
						<a href="http://unificationengine.com/terms-of-service/" target="_blank">{{ 'Footer.TermsOfService' | translate }}</a>
						<a href="http://unificationengine.com/privacy-policy/" target="_blank">{{ 'Footer.PrivacyPolicy' | translate }}</a>
						<span class="languageselector">{{ 'Footer.English' | translate }} 
							<!--<select #langSelect (change)="changeLang(langSelect.value)">  
							<option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">{{ lang }}</option>  
						</select>-->
						</span>
					</div>
				</div>
			</div>
			</div>
		</div>
	</footer>
</div>